import React from 'react';
import { PrimaryButton } from '@fluentui/react';
import styles from './../../styles/App.module.scss';
import { Navigate } from 'react-router-dom';

interface ISignedOutProps
{
}

export const SignedOut: React.FunctionComponent<ISignedOutProps> = (props: React.PropsWithChildren<ISignedOutProps>) => {  
  const [isLoggedIn] = React.useState<boolean>(false);

  if (isLoggedIn) {
    return <Navigate to={"/interessenter"} />;
  }

  return <>
      <div className={styles.loginContainer}>
        <div className={styles.login}>
          <h1>🔒</h1>
          <h3>Du er blevet logget ud automatisk</h3>
          <PrimaryButton text="Log på igen" onClick={() => { window.location.href = "/Login"; }} />
        </div>        
      </div>
    </>
}
export default SignedOut;